export function useLogout() {
    function cleanupCometChatListeners(CometChat) {
        try {
            CometChat.removeConnectionListener('CONNECTION_LISTENER');
        } catch (e) {
            // Listener may not exist
        }
    }

    async function logoutCometChat() {
        const CometChat = window.CometChat;

        if (!CometChat) {
            return;
        }

        try {
            const loggedInUser = await CometChat.getLoggedinUser();

            if (loggedInUser) {
                cleanupCometChatListeners(CometChat);
                await CometChat.logout();
            }
        } catch (error) {
            console.error('[useLogout] CometChat logout failed:', error);
        }
    }

    const handleLogout = async function (redirectToLogin = true) {
        const { usePreloader } = await import("@/composables/usePreloader");
        const { useNotifications } = await import("@/composables/useNotifications");
        const { useAuth } = await import("@/stores/AuthStore");
        const { useOnboarding } = await import("@/stores/OnboardingStore");
        const { useCookies } = await import("@vueuse/integrations/useCookies");
        const { useRouter } = await import("vue-router");
        const { storeToRefs } = await import("pinia");

        const { showPreloader, hidePreloader } = usePreloader();
        const { deleteFcmToken } = useNotifications();
        const router = useRouter();
        const cookie = useCookies(null, { doNotParse: true });

        const authStore = useAuth();
        const { token, user, member, organization, notificationToken } = storeToRefs(authStore);
        const { currentStep } = storeToRefs(useOnboarding());

        showPreloader();

        if (notificationToken.value !== null) {
            await deleteFcmToken(organization.value.slug, member.value.uid, notificationToken.value.uid)
                .then(() => {
                    notificationToken.value = null;
                }).catch(err => {
                    if (err.status === 404) {
                        console.log('notification token not found');
                    }
                });
        }

        token.value = null;
        user.value = null;
        authStore.clearChatToken();
        currentStep.value = 0;

        cookie.remove('user-uid', {
            path: '/',
            domain: window.appConfig.DOMAIN
        });
        await logoutCometChat();

        if(redirectToLogin) {
            window.location.href = '/login';
        }

        member.value = null;

        hidePreloader();
    };

    return {
        handleLogout,
        logoutCometChat,
    };
}
